import React from 'react'

export const Center960 = ({ children }) => (
  <div style={{
    maxWidth: `960px`,
    margin: `0 auto`,
  }}>
    {children}
  </div>
)

export const FloatLeft = ({ children }) => (
  <div style={{float: `left`}}>
    {children}
  </div>
)

export const FloatRight = ({ children }) => (
  <div style={{float: `right`}}>
    {children}
  </div>
)

export const ClearBoth = ({ children }) => (
  <div style={{clear: `both`}}>
    {children}
  </div>
)

export const InlineBlockTop = ({ children, style, ...props }) => (
  <div
      style={{
        display: `inline-block`,
        verticalAlign: `top`,
        ...style,
      }}
      {...props}
  >
    {children}
  </div>
)

export const InlineBlockCenter = ({ children, style, ...props }) => (
  <div
      style={{
        display: `inline-block`,
        verticalAlign: `center`,
        ...style,
      }}
      {...props}
  >
    {children}
  </div>
)

export const InlineBlockBottom = ({ children, style, ...props }) => (
  <div
      style={{
        display: `inline-block`,
        verticalAlign: `bottom`,
        ...style,
      }}
      {...props}
  >
    {children}
  </div>
)

export const VerticalAlignBottom = ({ children }) => (
  <div style={{verticalAlign: `bottom`}}>
    {children}
  </div>
)

export const Box = ({ children, style }) => (
  <div
      style={{
        margin: `5px 0 5px 0`,
        padding: `5px 5px 5px 10px`,
        ...style,
        // border: `1px solid black`,
        // boxShadow: `10px 10px 5px #888888`,
      }}
  >
    {children}
  </div>
)

export const ShadowedBox = ({ children, style }) => (
  <Box 
      style={{
        marginBottom: `20px`,
        border: `1px solid black`,
        boxShadow: `10px 10px 5px #888888`,
        ...style,
      }}
  >
    {children}
  </Box>
)

export const WhiteBox = ({ children }) => (
  <Box style={{backgroundColor: `white`}}>
    {children}
  </Box>
)

export const SerifSpan = ({ children, style }) => (
  <span style={{fontFamily: `"Times", "serif"`, ...style}}>
    {children}
  </span>
)

export const SerifDiv = ({ children, style }) => (
  <div style={{fontFamily: `"Times", "serif"`, ...style}}>
    {children}
  </div>
)

export const SansSerifSpan = ({ children, style }) => (
  <span style={{fontFamily: `"medium-content-sans-serif-font", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", "Geneva", "Arial", "sans-serif"`, ...style}}>
    {children}
  </span>
)

export const SansSerifDiv = ({ children, style }) => (
  <div style={{fontFamily: `"medium-content-sans-serif-font", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", "Geneva", "Arial", "sans-serif"`, ...style}}>
    {children}
  </div>
)

export const P = ({ children, style, ...props }) => (
  <div
      style={{
        display: `block`,
        margin: `1em 0`,
        ...style,
      }}
      {...props}
  >
    {children}
  </div>
)

export const H1 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h1
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h1>
  </SansSerifDiv>
)

export const H2 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h2
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h2>
  </SansSerifDiv>
)

export const H3 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h3
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h3>
  </SansSerifDiv>
)

export const H4 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h4
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h4>
  </SansSerifDiv>
)

export const H5 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h5
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h5>
  </SansSerifDiv>
)

export const H6 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h6
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h6>
  </SansSerifDiv>
)

export const H7 = ({ children, style, ...props }) => (
  <SansSerifDiv>
    <h7
        style={{
          margin: 0,
          padding: 0,
          ...style,
        }}
        {...props}
    >
      {children}
    </h7>
  </SansSerifDiv>
)

export class A extends React.Component {
  render() {
    const { style, ...passThruProps} = this.props

    return (
      <a
          style={{
            color: `black`,
            textDecoration: this.state.hover ? `underline` : `none`,
            ...this.props.style,
          }}
          onMouseOver={() => this.setState({hover: true})}
          onMouseLeave={() => this.setState({hover: false})}
          {...passThruProps}
      >
        {this.props.children}
      </a>
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      hover: false,
    }
  }
}

// export class Link extends React.Component {
//   render() {
//     const { style, ...passThruProps} = this.props

//     return (
//       <RRLink
//           style={{
//             color: `black`,
//             textDecoration: this.state.hover ? `underline` : `none`,
//             ...this.props.style,
//           }}
//           activeStyle={{
//             textDecoration: `underline`,
//           }}
//           onMouseOver={() => this.setState({hover: true})}
//           onMouseLeave={() => this.setState({hover: false})}
//           {...passThruProps}
//       >
//         {this.props.children}
//       </RRLink>
//     )
//   }

//   constructor(props) {
//     super(props)

//     this.state = {
//       hover: false,
//     }
//   }
// }

// export class IndexLink extends React.Component {
//   render() {
//     const {style, ...passThruProps} = this.props
//     return (
//       <RRIndexLink
//           activeStyle={{
//             textDecoration: `underline`,
//           }}
//           onMouseOver={() => this.setState({hover: true})}
//           onMouseLeave={() => this.setState({hover: false})}
//           style={{
//             color: `black`,
//             textDecoration: this.state.hover ? `underline` : `none`,
//             ...this.props.style,
//           }}
//           {...passThruProps}
//       >
//         {this.props.children}
//       </RRIndexLink>
//     )
//   }

//   constructor(props) {
//     super(props)

//     this.state = {
//       hover: false,
//     }
//   }
// }

export const Label = ({ children, htmlFor, style }) => (
  <SansSerifSpan style={{...style}}>
    <label htmlFor={htmlFor}>{children}</label>
  </SansSerifSpan>
)

export const OL = ({ children, ...props }) => (
  <ol {...props}>
    {children}
  </ol>
)

export const UL = ({ children, ...props }) => (
  <ul {...props}>
    {children}
  </ul>
)

export const InlineLI = ({ children, style }) => (
  <li style={{display: `inline`, ...style}}>
    {children}
  </li>
)



export const DarkGreenBackgroundDiv = ({ children }) => (
  <div style={{backgroundColor: `#336633`}}>
    {children}
  </div>
)

export const LightGreenBackgroundDiv = ({ children }) => (
  <div style={{backgroundColor: `#88AA88`}}>
    {children}
  </div>
)

export const FaintGreenBackgroundDiv = ({ children }) => (
  <div style={{backgroundColor: `#DDEDDD`}}>
    {children}
  </div>
)

export const WhiteBackgroundDiv = ({ children }) => (
  <div style={{backgroundColor: `white`}}>
    {children}
  </div>
)

export const WhiteTextDiv = ({ children }) => (
  <div style={{color: `white`}}>
    {children}
  </div>
)

export const CodeSpan = ({ children }) => (
  <span style={{
    backgroundColor: `#272822`,
    color: `#F8F8F2`,
    fontFamily: `"Consolas", "Menlo", "Monaco", "Lucida Console", "Liberation Mono", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Courier New", "monospace", "sans-serif"`,
    padding: `10px`,
  }}>
    {children}
  </span>
)

export const CodeDiv = ({ children }) => (
  <div style={{
    backgroundColor: `#272822`,
    color: `#F8F8F2`,
    fontFamily: `"Consolas", "Menlo", "Monaco", "Lucida Console", "Liberation Mono", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Courier New", "monospace", "sans-serif"`,
    padding: `10px`,
  }}>
    {children}
  </div>
)

export const CodeCommentSpan = ({ children }) => (
  <span style={{color: `#75715E`}}>
    {children}
  </span>
)

export const CodeCommentDiv = ({ children }) => (
  <div style={{color: `#75715E`}}>
    {children}
  </div>
)

export const CodeKeywordSpan = ({ children }) => (
  <span style={{color: `#F92672`}}>
    {children}
  </span>
)

export const CodeKeywordDiv = ({ children }) => (
  <div style={{color: `#F92672`}}>
    {children}
  </div>
)

export const CodeTypeSpan = ({ children }) => (
  <span style={{color: `#F92672`}}>
    {children}
  </span>
)

export const CodeTypeDiv = ({ children }) => (
  <div style={{color: `#F92672`}}>
    {children}
  </div>
)

export const CodeVariableSpan = ({ children }) => (
  <span style={{color: `#F92672`}}>
    {children}
  </span>
)

export const CodeVariableDiv = ({ children }) => (
  <div style={{color: `#F92672`}}>
    {children}
  </div>
)



// WEBPACK FOOTER //
// ./src/Styles.js